const danishCollator = new Intl.Collator("da-DK", { sensitivity: "base", usage: "sort" });

/**
 * Dansk alfabetisk sortering: æ, ø og å (inkl. aa som å) efter z.
 * Matcher server-side værksliste (`CultureInfo("da-DK")` i vaerksliste.cshtml).
 */
export function compareDanish(a: string, b: string): number {
    return danishCollator.compare(a ?? "", b ?? "");
}
